<nb-card>
  <nb-card-header>{{ ('crop' | translate) + ' ' + file.name }}</nb-card-header>
  <nb-card-body [nbSpinner]="loading">
    <image-cropper #cropper
                   [imageFile]="file"
                   [maintainAspectRatio]="!!ratio"
                   [aspectRatio]="ratio ? ratio : 1"
                   [roundCropper]="round"
                   [cropperMinHeight]="5"
                   [cropperMinWidth]="5"
                   [autoCrop]="false"
                   [backgroundColor]="background"
                   [containWithinAspectRatio]="false"
                   format="png"
                   (imageLoaded)="loading = false"
                   (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton (click)="this.cancel()">{{ 'no' | translate }}</button>
    <button nbButton (click)="this.submit()" status="primary">{{ 'save' | translate }}</button>
  </nb-card-footer>
</nb-card>
